import React, { useEffect, useState, Children, Fragment } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Download, ArrowRightIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../i18n/LanguageContext';
export function CatalogPage() {
  const {
    t
  } = useLanguage();
  const categories = [t('cat.tabs.all'), t('cat.tabs.smartpanel'), t('cat.tabs.smartstrips'), t('cat.tabs.smartfloor'), t('cat.tabs.smartdoor'), t('cat.tabs.smartsofa'), t('cat.tabs.smartmachinery'), t('cat.tabs.smartgarden')];
  const [activeTab, setActiveTab] = useState(categories[0]);
  // Update active tab if language changes
  useEffect(() => {
    setActiveTab(categories[0]);
  }, [t]);
  const catalogs = [
  // SmartPanel PVC
  {
    id: 1,
    title: t('cat.c1.title'),
    desc: t('cat.c1.desc'),
    category: t('cat.tabs.smartpanel'),
    section: 'SmartPanel PVC',
    image: 'https://cdn.magicpatterns.com/uploads/e2H8e2PiroSRBHx4KPN6pt/imagen_1_.png',
    pdf: 'https://drive.google.com/file/d/1zr8o2ejc-nEwgTB62OZIu_X_ayO2GWZK/view'
  }, {
    id: 2,
    title: t('cat.c2.title'),
    desc: t('cat.c2.desc'),
    category: t('cat.tabs.smartpanel'),
    section: 'SmartPanel PVC',
    image: 'https://cdn.magicpatterns.com/uploads/xfup8hSbCNYKXBBxS2gkqs/imagen_2_.png',
    pdf: 'https://drive.google.com/file/d/11_qZZR20t8PjtozmHmgo0r7NYOemQXcy/view'
  }, {
    id: 4,
    title: t('cat.c4.title'),
    desc: t('cat.c4.desc'),
    category: t('cat.tabs.smartpanel'),
    section: 'SmartPanel PVC',
    image: 'https://cdn.magicpatterns.com/uploads/mvBPYEy2KFFgoEHSkWFMhP/imagen_4.png',
    pdf: 'https://drive.google.com/file/d/1oe1Ef-yW8F0_ohmeId5-LoxuRe9__-OP/view'
  }, {
    id: 3,
    title: t('cat.c3.title'),
    desc: t('cat.c3.desc'),
    category: t('cat.tabs.smartpanel'),
    section: 'SmartPanel PVC',
    image: 'https://cdn.magicpatterns.com/uploads/jkdJsPMCjQfiNBGtjsbhRi/ChatGPT_Image_24_mar_2026,_13_59_47.png',
    pdf: 'https://drive.google.com/file/d/11_qZZR20t8PjtozmHmgo0r7NYOemQXcy/view'
  }, {
    id: 5,
    title: t('cat.c5.title'),
    desc: t('cat.c5.desc'),
    category: t('cat.tabs.smartpanel'),
    section: 'SmartPanel PVC',
    image: 'https://cdn.magicpatterns.com/uploads/oFBLozaBaDgqUGJ8TQTtUf/imagen_5.png',
    pdf: 'https://drive.google.com/file/d/1J0QkA1QOaTREaXyNeHt5wFfI1_2yjAy8/view'
  }, {
    id: 21,
    title: t('cat.c21.title'),
    desc: t('cat.c21.desc'),
    category: t('cat.tabs.smartpanel'),
    section: 'SmartPanel PVC',
    image: 'https://cdn.magicpatterns.com/uploads/nWsM9jHcBba9v933TTvYyc/imagen_67.png',
    pdf: 'https://drive.google.com/file/d/1B3zgsHzSHy_og0vWqzkg7TxdLTn34m_Q/view?usp=sharing'
  },
  // Bambú Collection
  {
    id: 16,
    title: t('cat.c16.title'),
    desc: t('cat.c16.desc'),
    category: t('cat.tabs.smartpanel'),
    section: 'SmartPanel Bambú',
    image: 'https://cdn.magicpatterns.com/uploads/dK8QU2EnaUxpLPjEkJ74YP/imagen_3.png',
    pdf: 'https://hangzhoutucegongfang.yunzhan365.com/books/sthb/mobile/index.html'
  },
  // Sintered Stone Collection
  {
    id: 17,
    title: t('cat.c17.title'),
    desc: t('cat.c17.desc'),
    category: t('cat.tabs.smartpanel'),
    section: 'Piedra Sinterizada',
    image: 'https://cdn.magicpatterns.com/uploads/mvBPYEy2KFFgoEHSkWFMhP/imagen_4.png',
    pdf: 'https://drive.google.com/file/d/1_jOnBvdvOFljR3HM4W2q2NLDG1Dltanq/view?usp=sharing'
  },
  // SmartStrips
  {
    id: 6,
    title: t('cat.c6.title'),
    desc: t('cat.c6.desc'),
    category: t('cat.tabs.smartstrips'),
    image: 'https://cdn.magicpatterns.com/uploads/1QWgQoHZGLaA3gcJ5cjVxN/imagen_6.png',
    pdf: 'https://drive.google.com/file/d/19PoNWPk4VsYqRmInjwgSO1sAV4qpgVZj/view'
  }, {
    id: 7,
    title: t('cat.c7.title'),
    desc: t('cat.c7.desc'),
    category: t('cat.tabs.smartstrips'),
    image: 'https://cdn.magicpatterns.com/uploads/5azsaFr29711XU6tqBRX51/imagen_34.png',
    pdf: 'https://drive.google.com/file/d/1phtSevN0BFRWBBl0eOfI190688BS9T-b/view?usp=sharing'
  }, {
    id: 19,
    title: t('cat.c19.title'),
    desc: t('cat.c19.desc'),
    category: t('cat.tabs.smartstrips'),
    image: 'https://cdn.magicpatterns.com/uploads/f6dVvoMz4K1H3AisR2wvGJ/44.png',
    pdf: 'https://drive.google.com/file/d/1dCTepUW6aaqIxpQzmDwUUZrOXSLwOjQt/view?usp=sharing'
  }, {
    id: 20,
    title: t('cat.c20.title'),
    desc: t('cat.c20.desc'),
    category: t('cat.tabs.smartstrips'),
    image: 'https://cdn.magicpatterns.com/uploads/o7QG96MFPHqW9AduGbi5Hn/60.png',
    pdf: 'https://drive.google.com/file/d/1SThGD7Ultt54pObYBsLJyIt68ySrNmUw/view?usp=sharing'
  }, {
    id: 22,
    title: t('cat.c22.title'),
    desc: t('cat.c22.desc'),
    category: t('cat.tabs.smartstrips'),
    image: 'https://cdn.magicpatterns.com/uploads/3zL3EhkNXGacuRSigg48EX/imagen_67.png',
    pdf: 'https://drive.google.com/file/d/1B3zgsHzSHy_og0vWqzkg7TxdLTn34m_Q/view?usp=sharing'
  },
  // SmartFloor
  {
    id: 8,
    title: t('cat.c8.title'),
    desc: t('cat.c8.desc'),
    category: t('cat.tabs.smartfloor'),
    image: 'https://cdn.magicpatterns.com/uploads/gRfJLW7PxKZxjKHLT2Xmzr/IMAGEN_8.png',
    pdf: 'https://drive.google.com/file/d/1rWzjnj_XxpG9ZI41Dv4ZklwnkjUOVHIu/view'
  }, {
    id: 9,
    title: t('cat.c9.title'),
    desc: t('cat.c9.desc'),
    category: t('cat.tabs.smartfloor'),
    image: 'https://cdn.magicpatterns.com/uploads/nNUbf4LPaf5wF4XvTd2qoZ/imagen_9.png',
    pdf: 'https://drive.google.com/file/d/1rx5l0D3CiLPa9YYLxGzaFy6xNQLa_Q6p/view'
  },
  // SmartDoor
  {
    id: 10,
    title: t('cat.c10.title'),
    desc: t('cat.c10.desc'),
    category: t('cat.tabs.smartdoor'),
    image: 'https://cdn.magicpatterns.com/uploads/jeWLN5JDxfnrzS8UYpYnxU/imagen_10_.png',
    pdf: 'https://drive.google.com/file/d/1cY9ruqc99fFkPyl7Yoo7qjkQmL7LZpUC/view'
  }, {
    id: 18,
    title: t('cat.c18.title'),
    desc: t('cat.c18.desc'),
    category: t('cat.tabs.smartdoor'),
    image: 'https://cdn.magicpatterns.com/uploads/fXvRU9k3NmHGfrvuJdKNdE/puerta_blindada_.png',
    pdf: 'https://drive.google.com/file/d/1bSKeWyOCwVZHoWeGR5R46EcPhcSoOytN/view?usp=sharing'
  },
  // SmartGarden
  {
    id: 12,
    title: t('cat.c12.title'),
    desc: t('cat.c12.desc'),
    category: t('cat.tabs.smartgarden'),
    image: 'https://cdn.magicpatterns.com/uploads/6oREtUuCTedvJa5nfaNgJp/72d54d56-e310-4c14-a578-615cb3f1513b.png',
    pdf: ''
  },
  // SmartSofa
  {
    id: 13,
    title: t('cat.c13.title'),
    desc: t('cat.c13.desc'),
    category: t('cat.tabs.smartsofa'),
    image: 'https://cdn.magicpatterns.com/uploads/w7gh4qkou5CE2jaU5R8Yjh/sofa.png',
    pdf: 'https://drive.google.com/file/d/1l6HV07j4u3_p7Lt_1rlBz8dNuVF7wBOh/view?usp=sharing'
  },
  // SmartMachinery
  {
    id: 14,
    title: t('cat.c14.title'),
    desc: t('cat.c14.desc'),
    category: t('cat.tabs.smartmachinery'),
    image: 'https://cdn.magicpatterns.com/uploads/9sh2x84vbgDoahGbf9mmV3/maquina.png',
    pdf: 'https://drive.google.com/file/d/1b3R-B4X0Oa7fQ8sT3HsY6Y2UthPdbUzF/view?usp=sharing'
  },
  // SmartGarden (additional)
  {
    id: 15,
    title: t('cat.c15.title'),
    desc: t('cat.c15.desc'),
    category: t('cat.tabs.smartgarden'),
    image: 'https://cdn.magicpatterns.com/uploads/1xBEAawceEfKSHpm3h3mwj/cesped.png',
    pdf: ''
  }];
  const isAllTab = activeTab === categories[0];
  const filteredCatalogs = isAllTab ? catalogs : catalogs.filter(item => item.category === activeTab);
  return <div className="w-full bg-white min-h-screen pb-32" data-id="element-157">
      {/* Hero */}
      <div className="relative h-[45vh] md:h-[50vh] w-full flex items-center justify-center overflow-hidden mb-16" data-id="element-158">
        <div className="absolute inset-0 z-0" data-id="element-159">
          <img src="https://cdn.magicpatterns.com/uploads/8KzJfoRaQYshBKXbfrjzn2/Imagen_4_—_Catalogo_de_materiales.png" alt="Catálogo" className="w-full h-full object-cover" data-id="element-160" />
          <div className="absolute inset-0 bg-corporate-dark/80" data-id="element-161"></div>
        </div>
        <div className="relative z-10 text-center px-4 mt-16" data-id="element-162">
          <motion.h1 initial={{
          opacity: 0,
          y: 40
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          ease: [0.25, 0.1, 0.25, 1]
        }} className="text-5xl md:text-6xl font-heading font-bold text-white mb-6 tracking-tight" data-id="element-163">
            {t('cat.hero.title')}
          </motion.h1>
          <motion.p initial={{
          opacity: 0,
          y: 40
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.2,
          duration: 0.8,
          ease: [0.25, 0.1, 0.25, 1]
        }} className="text-xl text-gray-200 max-w-2xl mx-auto font-light" data-id="element-164">
            {t('cat.hero.desc')}
          </motion.p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-165">
        {/* Filter Tabs */}
        <div className="flex flex-wrap justify-center gap-3 md:gap-6 mb-16" data-id="element-166">
          {categories.map(cat => <button key={cat} onClick={() => setActiveTab(cat)} className={`px-6 py-3 text-sm font-medium rounded-full transition-all duration-500 ease-premium ${activeTab === cat ? 'bg-corporate-blue text-white shadow-md' : 'bg-neutral-grey text-gray-600 hover:bg-gray-200 hover:shadow-sm'}`} data-id="element-167">
              {cat}
            </button>)}
        </div>

        {/* Catalog Cards Grid */}
        {filteredCatalogs.length > 0 ? <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10" data-id="element-168">
            <AnimatePresence mode="wait" data-id="element-169">
              {filteredCatalogs.map((catalog, index) => {
            const prevSection = index > 0 ? filteredCatalogs[index - 1].section : null;
            const showSectionTitle = catalog.section && catalog.section !== prevSection;
            return <Fragment key={catalog.id} data-id="element-170">
                    {showSectionTitle && <div className={`col-span-1 sm:col-span-2 lg:col-span-3 ${index > 0 ? 'mt-8' : ''}`} data-id="element-171">
                        <h3 className="text-2xl font-heading font-semibold text-corporate-dark tracking-tight" data-id="element-172">
                          {catalog.section}
                        </h3>
                      </div>}
                    <motion.div initial={{
                opacity: 0,
                scale: 0.98
              }} animate={{
                opacity: 1,
                scale: 1
              }} exit={{
                opacity: 0,
                scale: 0.98
              }} transition={{
                duration: 0.25,
                ease: [0.4, 0, 0.2, 1]
              }} className="bg-neutral-grey rounded-sm overflow-hidden group border border-gray-100 hover:-translate-y-2 hover:shadow-xl transition-all duration-500 ease-premium flex flex-col" data-id="element-173">
                      <div className="h-64 relative overflow-hidden" data-id="element-174">
                        <img src={catalog.image} alt={catalog.title} className="w-full h-full object-cover transition-transform duration-700 ease-premium group-hover:scale-110" data-id="element-175" />
                      </div>
                      <div className="p-8 flex flex-col flex-1" data-id="element-176">
                        <span className="text-xs font-bold text-accent-beige uppercase tracking-wider mb-3 block" data-id="element-177">
                          {catalog.category}
                        </span>
                        <h3 className="text-xl font-heading font-bold text-corporate-dark mb-3 tracking-tight" data-id="element-178">
                          {catalog.title}
                        </h3>
                        <p className="text-base text-gray-600 font-light leading-relaxed mb-6 flex-1" data-id="element-179">
                          {catalog.desc}
                        </p>
                        {catalog.pdf ? <a href={catalog.pdf} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-6 py-3 border-2 border-corporate-blue text-corporate-blue hover:bg-corporate-blue hover:text-white transition-all duration-500 ease-premium rounded-md text-sm font-medium hover:scale-[1.02] w-full" data-id="element-180">
                            <Download className="mr-2 h-4 w-4" data-id="element-181" />
                            {t('cat.download.btn')}
                          </a> : <span className="inline-flex items-center justify-center px-6 py-3 border-2 border-gray-300 text-gray-400 rounded-md text-sm font-medium w-full cursor-default" data-id="element-182">
                            {t('cat.coming.soon')}
                          </span>}
                      </div>
                    </motion.div>
                    {catalog.section && (index === filteredCatalogs.length - 1 || filteredCatalogs[index + 1].section !== catalog.section) && <div className="col-span-1 sm:col-span-2 lg:col-span-3 flex flex-col items-center mt-6 mb-4" data-id="element-183">
                          <p className="text-sm text-gray-500 font-light mb-3" data-id="element-184">
                            {t('cat.viewAll.subtitle')}
                          </p>
                          <Link to="/soluciones/smartpanel" className="inline-flex items-center justify-center px-8 py-3 border-2 border-corporate-blue text-corporate-blue hover:bg-corporate-blue hover:text-white transition-all duration-500 ease-premium rounded-md text-sm font-medium hover:scale-[1.02]" data-id="element-185">
                            {t('cat.viewAll.btn')}
                            <ArrowRightIcon className="ml-2 h-4 w-4" data-id="element-186" />
                          </Link>
                        </div>}
                  </Fragment>;
          })}
            </AnimatePresence>
          </div> : <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.4,
        ease: [0.25, 0.1, 0.25, 1]
      }} className="text-center py-20" data-id="element-187">
            <p className="text-gray-400 font-light text-lg" data-id="element-188">
              {t('cat.coming.soon')}
            </p>
          </motion.div>}
      </div>
    </div>;
}